import Chart from '@app/components/atoms/Chart/Chart'
import { toDataChart, toTotal } from '@app/libs/dashboardFormat'
import { formatNumber, toMonthString } from '@app/libs/format'
import { optionsBarLine, optionsBarMix, optionsPie } from '@app/modules/Partner/Dashboard/ChartOption'
import { BarLine, dataChart, dataMix } from '@data/ChartData'
import Grid from '@mui/material/Grid'
import moment from 'moment'
import { useTranslation } from 'react-i18next'

const Dashboard = ({
  sumCodes,
  countRedeemed,
  valueRedeemed,
  valueUsed,
  countUsed,
  countDetailWeekly,
  countDetailMonthly,
  countDetailYear,
  categoriesVoucher,
}) => {
  const { t, i18n } = useTranslation()

  const vouchersCategoryChartData = dataChart(
    'TOTAL_VOUCHERS_CATEGORY',
    categoriesVoucher.filter((item) => 0 < item.vouchers_count),
    toTotal(categoriesVoucher, 'vouchers_count'),
    'vouchers_count'
  )

  const label = [
    t('ADMIN_DASHBOARD.LABEL_CODE_AMOUNT', { textEn: 'redeemed', textVn: 'đã quy đổi' }),
    t('ADMIN_DASHBOARD.LABEL_CODE_AMOUNT', { textEn: 'used', textVn: 'đã sử dụng' }),
  ]

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Grid container alignItems="center" justifyContent="center" spacing={2}>
          <Grid item xs={6}>
            <Chart
              data={{
                title: t('ADMIN_DASHBOARD.LABEL_CODE_USED_AMOUNT'),
                tag: t('ADMIN_DASHBOARD.LABEL_CODE_USED_AMOUNT'),
                label: t('ADMIN_DASHBOARD.LABEL_CODE_AMOUNT', { textEn: 'redeemed', textVn: 'đã quy đổi' }),
                redeem: formatNumber(sumCodes.count_used),
                scope: null,
                total: formatNumber(parseInt(sumCodes.count_redeemed) + parseInt(sumCodes.count_used)),
              }}
              type="barLine"
            />
          </Grid>
          <Grid item xs={6}>
            <Chart
              data={{
                title: t('ADMIN_DASHBOARD.CHART_VALUE_USED_DIVIDE_VALUE_REDEEMED_TITLE'),
                tag: t('ADMIN_DASHBOARD.TOTAL_CODES_USED'),
                label: t('ADMIN_DASHBOARD.LABEL_CODE_VALUE', { textEn: 'redeemed', textVn: 'đã quy đổi' }),
                redeem: parseInt(sumCodes.count_price_used),
                scope: 'M',
                total: parseInt(sumCodes.count_price),
              }}
              type="barLine"
            />
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={12}>
        <Grid container spacing={2}>
          <Chart
            data={BarLine(
              t('ADMIN_DASHBOARD.LABEL_CODE_VALUE', { textEn: 'redeemed', textVn: 'đã quy đổi' }),
              t('ADMIN_DASHBOARD.LABEL_CODE_AMOUNT', { textEn: 'redeemed', textVn: 'đã quy đổi' }),
              toDataChart(countRedeemed, 'count'),
              toDataChart(valueRedeemed, 'value'),
              'redeemed',
              'point'
            )}
            styleChart={{ options: optionsBarLine }}
            styleGird={{ lg: 6, md: 6, xs: 6 }}
            title={t('ADMIN_DASHBOARD.CHART_AMOUNT_AND_VALUE_REDEEMED_IN_MONTH', { number: toMonthString(moment()) })}
            type="bar"
          />
          <Chart
            data={BarLine(
              t('ADMIN_DASHBOARD.LABEL_CODE_VALUE', { textEn: 'used', textVn: 'đã sử dụng' }),
              t('ADMIN_DASHBOARD.LABEL_CODE_AMOUNT', { textEn: 'used', textVn: 'đã sử dụng' }),
              toDataChart(countUsed, 'redeemed', 'used'),
              toDataChart(valueUsed, 'point', 'price'),
              'used',
              'price'
            )}
            styleChart={{ options: optionsBarLine }}
            styleGird={{ lg: 6, md: 6, xs: 6 }}
            title={t('ADMIN_DASHBOARD.CHART_AMOUNT_AND_VALUE_USED_IN_MONTH', { number: toMonthString(moment()) })}
            type="bar"
          />
        </Grid>
      </Grid>
      <Grid item xs={12}>
        <Grid container spacing={2}>
          <Chart
            data={dataMix(
              label,
              countDetailWeekly.count_redeemed,
              countDetailWeekly.count_used,
              countDetailWeekly.count_code
            )}
            styleChart={{ options: optionsBarMix }}
            styleGird={{ lg: 4, md: 4, xs: 4 }}
            title={t('ADMIN_DASHBOARD.CHART_DETAIL_AMOUNT_REDEEMED_USED_TITLE', { paramsEn: 'week', paramsVn: 'tuần' })}
            type="bar"
          />
          <Chart
            data={dataMix(
              label,
              countDetailMonthly.count_redeemed,
              countDetailMonthly.count_used,
              countDetailMonthly.count_code
            )}
            styleChart={{ options: optionsBarMix }}
            styleGird={{ lg: 4, md: 4, xs: 4 }}
            title={t('ADMIN_DASHBOARD.CHART_DETAIL_AMOUNT_REDEEMED_USED_TITLE', {
              paramsEn: 'month',
              paramsVn: 'tháng',
            })}
            type="bar"
          />
          <Chart
            data={dataMix(
              label,
              countDetailYear.count_redeemed,
              countDetailYear.count_used,
              countDetailYear.count_code
            )}
            styleChart={{ options: optionsBarMix }}
            styleGird={{ lg: 4, md: 4, xs: 4 }}
            title={t('ADMIN_DASHBOARD.CHART_DETAIL_AMOUNT_REDEEMED_USED_TITLE', { paramsEn: 'year', paramsVn: 'năm' })}
            type="bar"
          />
        </Grid>
      </Grid>
      <Chart
        data={vouchersCategoryChartData}
        styleChart={{ options: optionsPie(t, i18n) }}
        styleGird={{ lg: 4, md: 6, xs: 6 }}
        title={t(`ADMIN_DASHBOARD.${vouchersCategoryChartData.label}`)}
        type="doughnut"
      />
    </Grid>
  )
}

export default Dashboard
